import { render } from "./MyFooter.vue?vue&type=template&id=3b8d006e&scoped=true"
const script = {}

import "./MyFooter.vue?vue&type=style&index=0&id=3b8d006e&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8d006e"]])

export default __exports__